import React from 'react';

import VelocityChart from './velocity-chart';
import style from '../forecasting-grid.module.less';
import { useGridChartData } from '../hooks/use-grid-chart-data';

/**
 * VelocityChartSubRow component for rendering expanded row content
 * @param {object} props - Component props
 * @param {string} props.productId - The product ID
 * @param {boolean} props.hasSufficientHistoricalData - Whether product has enough historical data
 * @param {boolean} props.isExpanded - Whether the row is expanded
 * @returns {React.ReactElement} The rendered VelocityChart component
 */
export const Index = ({ productId, hasSufficientHistoricalData, isExpanded }) => {
  const { chartData, isLoading } = useGridChartData(productId);

  if (!isExpanded) {
    return null;
  }

  return (
    <div className={style['expanded-content']}>
      <VelocityChart data={chartData} hasSufficientHistoricalData={hasSufficientHistoricalData === true} isLoading={isLoading} />
    </div>
  );
};
